// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vendor-feedback-modal{width:100%;max-width:400px;min-width:400px}.vendor-feedback-modal__divider{border-bottom:1px solid #f2f1f4;margin:24px -32px 32px}.vendor-feedback-modal__title{text-align:center}@media(max-width: 576px){.vendor-feedback-modal__title{text-align:left}}", ""]);
// Exports
module.exports = exports;
